import { useSelectSignalsBroadcastState } from '@kinetic-ui/broadcast';
import {
  CombinedTableControls,
  FlexScroll,
  NameColumn,
  SelectionColumn,
  Table,
  TableHeaderButton,
} from '@kinetic-ui/shared';
import { useSelectSignalsControls } from './useSelectSignalsControls';
import { useSelectSignalsData } from './useSelectSignalsData';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
export const SelectSignals = () => {
  const { t } = useTranslation('signals');
  const [, setValue] = useSelectSignalsBroadcastState();
  const [selection, setSelection] = useState<string[]>([]);
  const onComplete = () => {
    const selectedSignals = selection.reduce((acc, id) => {
      return { ...acc, [id]: true };
    }, {});
    setValue(selectedSignals);
  };

  const {
    state: { filterInputs, searchText },
    combinedTableControlsProps,
  } = useSelectSignalsControls();

  const { signals, onSortChange, sort, InViewComponent, infiniteFooter } = useSelectSignalsData({
    filters: filterInputs,
    searchText,
  });

  type RowType = (typeof signals)[0];

  return (
    <CombinedTableControls {...combinedTableControlsProps}>
      <CombinedTableControls.CardHeader
        leftSlot={
          <TableHeaderButton onClick={onComplete}>
            {t('completeSignalsSelection')}
          </TableHeaderButton>
        }
      />
      <FlexScroll>
        <Table
          data={signals}
          onSortChange={onSortChange}
          sort={sort}
          extraContent={InViewComponent}
          selection={selection}
          setSelection={setSelection}
        >
          <CombinedTableControls.Drawer />
          <SelectionColumn />
          <NameColumn<RowType> getValue={({ details: { name } }) => name} />
        </Table>
      </FlexScroll>
      {infiniteFooter}
    </CombinedTableControls>
  );
};
